import { Spacer } from "../../../../components/common/Spacer";
import { Typography } from "antd";
import ErrorLabel from "views/components/common/ErrorLabel/ErrorLabel";
import Input from "views/components/common/Input/Input";
import React, { useEffect, useState } from "react";

const { Text } = Typography;

export const Step2 = ({
	onChange,
	value,
	setIsDisabled,
	errors,
	info,
	corp,
}) => {
	const [match, setMatch] = useState({});

	useEffect(() => {
		if (value.password !== value.passwordConfirm) {
			setMatch({ must: "La contraseña debe coincidir" });
			setIsDisabled(true);
		} else if (info.hasOwnProperty("isEmpty")) {
			setIsDisabled(true);
		} else {
			setMatch({});
			setIsDisabled(false);
		}
	}, [value]);

	return (
		<>
			{corp ? (
				<>
					<Text type="secondary">
						Hemos detectado que tienes una cuenta corporativa,
						necesitamos mayor seguridad en tu contraseña
					</Text>
					<Spacer rows={1} />
					<Input
						name="password"
						label="Contraseña"
						placeholder=""
						required={true}
						type="password-strong"
						onChange={onChange}
					/>
					<ErrorLabel inputErrors={errors} />
					<Spacer rows={1} />
					<Input
						name="passwordConfirm"
						label="Confirma tu contraseña"
						placeholder=""
						required={true}
						type="password-confirm-strong"
						onChange={onChange}
					/>
					<ErrorLabel match={match} />
				</>
			) : (
				<>
					<Input
						name="password"
						label="Contraseña"
						placeholder=""
						required={true}
						type="password-weak"
						onChange={onChange}
					/>
					<ErrorLabel inputErrors={errors} weak={true} />
					<Spacer rows={1} />
					<Input
						name="passwordConfirm"
						label="Repite la contraseña"
						placeholder=""
						required={true}
						type="password-confirm"
						onChange={onChange}
					/>
					<ErrorLabel match={match} />
				</>
			)}
		</>
	);
};
